<template>
    <div>
        <h4 class="">{{init_config.notify_description}}</h4>
        <v-row>
            <v-col offset="1">
                <v-row>
                    <v-col cols="5">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                outlined
                                dense
                                v-model="config.time_at"
                                label="Время отправки уведомления"
                                prepend-icon="mdi-clock-time-four-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-time-picker
                            v-if="menu"
                            format="24hr"
                            v-model="config.time_at"
                            full-width
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="menu = false"
                            >
                                OK
                            </v-btn>
                            </v-time-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="5">
                        <v-autocomplete
                            label="Часовой пояс"
                            outlined
                            dense
                            :items="timezones"
                            item-value="name"
                            item-text="title"
                            v-model="config.timezone"
                            ></v-autocomplete>
                    </v-col>
                    <v-btn
                        color="success"
                        class="mr-4 mt-3"
                        @click="onSave"
                    >
                    Обновить
                    </v-btn>
                </v-row>
            </v-col>

        </v-row>
    </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex'
import * as api from '@/api/workspace';
export default {
    name: 'WorkSpaceNotify',
    components:{
    },
    props: {
        init_config: {
            required: true,
            type: Object
        },
        timezones: {
            type: Array,
            required: true,
        }
    },
    data () {
        return {
            menu: false,
            config: {
                time_at: '',
                timezone: '',
            },
            isFetching: false
        }
    },
    created(){
        this.config.time_at = this.init_config.real_time_at;
        this.config.timezone = this.init_config.timezone;
    },
    watch:{
        isFetching: function(newV, oldV){
            if(newV != oldV){
                this.$emit('fetching', newV);
            }
        }
    },
    methods: {
        async onSave(){
            this.isFetching = true;
            try{
                if(this.init_config.id !== null){
                    await this.update();
                }else{
                    await this.save();
                }
            }catch(e){
                console.log(e);
            }finally{
                this.isFetching = false;
            }
        },
        async save(){
            try{
                let response = await api.notifyConfigStore(this.ID_WORK_SPACE, {
                    notify_type: this.init_config.notify_type,
                    ...this.config
                });
                this.$emit('save', response.data);
                this.SHOW_SUCCESS('Расписание успешно сохранено');
            }catch(e){
                console.log(e);
                this.SHOW_ERROR(e);
            }
        },

        async update(){
            try{
                let response = await api.notifyConfigUpdate(this.ID_WORK_SPACE, this.init_config.id, {
                    notify_type: this.init_config.notify_type,
                    ...this.config
                });
                this.$emit('update', response.data);
                this.SHOW_SUCCESS('Расписание успешно сохранено');
            }catch(e){
                console.log(e);
                this.SHOW_ERROR(e);
            }
        },
        ...mapActions('notifications', ['SHOW_ERROR', 'SHOW_SUCCESS']),
    },
    computed:{
        ...mapGetters('workspace', ['ID_WORK_SPACE'])
    }
}
</script>